// extracted by mini-css-extract-plugin
export default {"toolbar":"ProjectionSimulatePanel_toolbar__gsaNz","field":"ProjectionSimulatePanel_field__2Du94","label":"ProjectionSimulatePanel_label__hdKpG"};